import { useEffect, useState } from 'react';

export const useImageBlob = (image?: Blob) => {
  const [imageUrl, setImageUrl] = useState<string>();
  useEffect(() => {
    if (!image) return;
    const imageBlob = new Blob([image], { type: 'image/jpeg' });
    const url = URL.createObjectURL(imageBlob);
    setImageUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [image]);
  return imageUrl;
};
